import {useQuery} from 'react-query'

async function getCreditStudent(id)
{
    const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/student/Credit/${id}`)
    return response.json()
}

export const useStudentCredit = (id)=>
{
    return useQuery(['get-student-credit',id],()=>getCreditStudent(id))
}